/**
 * Módulos opt-in: sin fila en modulePermissions (o sin hasAccess === true) → sin acceso.
 * Sincronizar con smart_back permission-guard.ts y smart_front useModulePermissions.js
 */
export const MODULE_IDS_REQUIRE_EXPLICIT_GRANT = [
  'reportes_personalizados',
  'cobranza',
  'eoaf',
  'repositorio_auditorias',
  'repositorio_cartola_diaria',
  'haberes_variables',
  // Centro de descargas async (opt-in)
  'descargas',
  'cargar_nuevo_empleado',
  'contratos_proximos_a_vencer',
  'validador_liquidaciones',
  // Contabilidad: sin grant → OFF (USER_SMARTCFO e invitados no la ven por defecto)
  'contabilidad',
  'eerr',
  'eerr_contable',
  'balance_8_columnas',
  'balance_clasificado',
  'libro_mayor',
  'libro_diario',
  'asientos',
  'plan_cuentas',
  'centralizacion_contable',
  'libro_compra_venta',
  'cierre_apertura_contable',
]

export function isExplicitGrantModule(moduleId) {
  return MODULE_IDS_REQUIRE_EXPLICIT_GRANT.includes(moduleId)
}

export function defaultExplicitGrantModuleAccess(existingPerm) {
  if (!existingPerm) return false
  if (existingPerm.hasAccess === true) return true
  if (existingPerm.hasAccess === false) return false
  return false
}
